import { useEffect, useState } from 'react';

import { getBuildInfo } from '@lexio/shared';

import { getHealth } from '../lib/api';

function labelOf(version: string, git: string, built: string): string {
  const rev = git === 'local' ? 'vývoj' : git;
  return built ? `${version} · ${rev} · ${built}` : `${version} · ${rev}`;
}

/** Service worker si stahne novou verzi, pak stranku nacteme znovu. */
async function reloadFresh(): Promise<void> {
  try {
    const regs = (await navigator.serviceWorker?.getRegistrations()) ?? [];
    await Promise.all(regs.map((r) => r.update()));
  } catch {
    // Bez service workeru staci obycejne obnoveni.
  }
  window.location.reload();
}

/**
 * Vzdy viditelna identita buildu. Ukazuje verzi otevrene stranky (bundle);
 * kdyz server bezi na jine, rekne to a nabidne obnoveni - jinak by stary
 * web v cache vypadal jako novy.
 */
export function BuildStamp() {
  const bundled = getBuildInfo();
  const [server, setServer] = useState<{ version: string; git: string } | null>(null);

  useEffect(() => {
    void getHealth()
      .then((h) => setServer({ version: h.version, git: h.git }))
      .catch(() => {
        /* zustane jen otisk bundlu */
      });
  }, []);

  const label = labelOf(bundled.version, bundled.git, bundled.built);
  const outdated =
    server !== null && bundled.git !== 'local' && server.git !== 'local' && server.git !== bundled.git;

  useEffect(() => {
    document.title = `Lexio ${label}`;
  }, [label]);

  return (
    <p className="build-stamp">
      Lexio <strong>{label}</strong>
      {outdated && (
        <>
          {' · '}
          <button type="button" className="stamp-update" onClick={() => void reloadFresh()}>
            na serveru je {server.version} – obnovit
          </button>
        </>
      )}
    </p>
  );
}
